import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import Donate from '../views/DonateRoute.vue';
import Erreur from '../views/ErrorView.vue';
import SaisirPaiementPaysafe from '../views/SaisirPaiementPaysafe.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/erreur',
    name: 'Erreur',
    component: Erreur
  },
  {
    path: '/paiement/:tab/:fileId',
    name: 'SaisirPaiementPaysafe',
    component: SaisirPaiementPaysafe
  },
  {

    path: '/:campaign_slug',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/:campaign_slug/donate',
    name: 'Donate',
    component: Donate
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;